// src/pages/Proposals/FileDialog/forms/common/InfrastructureSelect.js
import React from "react";
import PropTypes from "prop-types";
import EntitySelect from "../common/EntitySelect";

function InfrastructureSelect({
  value,
  onChange,
  institution,
  label = "Infrastructure",
  sx,
}) {
  const endpoint =
    institution != null && institution !== ""
      ? `/infrastructure/?institution=${institution}`
      : null;

  return (
    <EntitySelect
      value={value}
      onChange={onChange}
      endpoint={endpoint}
      label={label}
      getOptionLabel={(opt) => opt?.name || ""}
      searchParam="search"
      sx={sx}
    />
  );
}
InfrastructureSelect.propTypes = {
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.oneOf([null])]),
  onChange: PropTypes.func.isRequired,
  institution: PropTypes.number,
  label: PropTypes.string,
  sx: PropTypes.object,
};
InfrastructureSelect.defaultProps = {
  value: null,
  institution: null,
  label: "Infrastructure",
  sx: {},
};

export default React.memo(InfrastructureSelect);
